import LeadFormListener from "./custom/form/LeadFormListener";
import GLightbox from 'glightbox';
import Swiper from "swiper";
import { Keyboard, Navigation, EffectFade, Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Rellax from 'rellax'
import { Smoother } from "./custom/Smoother";
import MapListener from "./custom/MapListener";
import 'overlayscrollbars/overlayscrollbars.css'
import { OverlayScrollbars, ScrollbarsHidingPlugin, SizeObserverPlugin, ClickScrollPlugin } from "overlayscrollbars";

const leadFormListener = new LeadFormListener();
const mapListener = new MapListener();

document.addEventListener('DOMContentLoaded', () => {
    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 16
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1170: {
                slidesPerView: 6,
                spaceBetween: 16
            },
            1500: {
                slidesPerView: 8,
                spaceBetween: 16
            }
        },
        modules: [Navigation, Keyboard],
        keyboard: {
            enabled: true,
        },
    });
    const swiperCarousel = new Swiper('.swiper-carousel', {
        direction: 'horizontal',
        loop: true,
        breakpoints: {
            0: {
                slidesPerView: 1
            }
        },
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            pauseOnMouseEnter: false
        },
        effect: 'fade',
        modules: [Autoplay, EffectFade],
        keyboard: {
            enabled: false,
        },
    });

    const swiperLightbox = GLightbox({
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        selector: '.swiper-slide-lightbox a'
    });

    if (window.scrollX > 0) { // Fix na przesunięcie po odświeżeniu strony, spowodowane istnieniem elementu typu fixed.
        window.scrollBy((window.scrollX * -1), 0);
    }

    const smoother = new Smoother({
        smooth: 1,
        effects: true,
        smoothTouch: .25
    });

    if (document.querySelectorAll('.rellax').length > 0) {
        const rellax = new Rellax('.rellax', {
            // wrapper:'#smooth-content',
            center: true,
            speed: 2
        });
    }
});